import React from "react";
import "../../App.css";

const Loader = () => {
  return (
    <div className="loaderBg">
      <div className="loaderArea"></div>
    </div>
  );
};

export default Loader;
